let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hKiCe")).then(() => parcelRequire('8ROwp'));